import { useScrollToSelectedItem } from "../useScrollToSelectedItem.js";
import { useClickAwayProps } from "./useClickAwayProps.js";
import { useDropdownProps } from "./useDropdownProps.js";
import { useDurationInputState } from "./useDurationInputState.js";
import { usePaperWidth } from "./usePaperWidth.js";
import { usePopperProps } from "./usePopperProps.js";
import { useRootProps } from "./useRootProps.js";
import { useTextfieldProps } from "./useTextfieldProps.js";
function useDurationInput(props) {
  const { state, dispatch } = useDurationInputState(props);
  const { displayValue, error, fieldValue, open, dropdownOptions, dropdownSelectedIndex } = state;
  const { rootProps, rootRef } = useRootProps(props);
  const textFieldProps = useTextfieldProps(dispatch, state, props);
  const dropdownProps = useDropdownProps(dispatch);
  const paperWidth = usePaperWidth(rootRef);
  const { popperProps, popperRef } = usePopperProps(state, rootRef);
  const clickAwayProps = useClickAwayProps(dispatch);
  useScrollToSelectedItem(state, popperRef);
  return {
    textFieldProps,
    dropdownProps,
    rootProps,
    open,
    error,
    displayValue,
    fieldValue,
    dropdownOptions,
    paperWidth,
    popperProps,
    dropdownSelectedIndex,
    clickAwayProps
  };
}
export {
  useDurationInput
};
//# sourceMappingURL=useDurationInput.js.map
